import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { FreemiumAPIService } from 'src/app/webtree-website/freemium-api.service';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { AtsResumePollingService } from 'src/app/_services/ats-resume-polling.service';
import { UnifiedService } from 'src/app/unified/unified.service';
import { IUnifiedIntegration } from 'src/app/unified/unified.types';
declare const clevertap;

type SCREENING_CRITERIA = { criteria_id?: number, criteria_name: string, criteria_type: string, criteria_content: string, job_id: number, isactive?: boolean, created_on?: string, criteriacontent?: string, projectcriteriaid?: string, criteria_priority?: any, ats_criteria_id?: any };
type SCREENING_CRITERIA_SUGGESTION = { suggestion_id?: number, suggestion_name?: string, suggestion_content: string, created_on?: string, selected: boolean };

@Component({
    selector: 'app-screening-criteria',
    templateUrl: './screening-criteria.component.html',
    styleUrls: ['./screening-criteria.component.scss'],
    standalone: false
})
export class ScreeningCriteriaComponent implements OnInit {

  @ViewChild('jobCreatedSuccessfullModel') jobCreatedSuccessfullModel: TemplateRef<any>;

  suggestedEvaluationCriteria: String[] = [];
  displayedEvaluationCriteria: String[] = [];
  selectedEvaluationCriteria: String[] = [];

  disableButton: boolean = false;
  showExploreCandidateSpinner: boolean = false;

  /**Hide static suggestions */
  hideSuggestions: boolean = false;

  /**Used to know any unsaved changes or not */
  unSavedChanges: boolean = false;

  jobid: string = '';
  showEvaluationCriteriaLoader: Boolean = false;

  @Input() tab: any;
  @Input() jobDetails: any;
  isProjectDetailsEvaluationCriteriaTab: Boolean = false;
  editMode: Boolean = false;

  SUGGESTED_CRITERIA: SCREENING_CRITERIA_SUGGESTION[] = [];
  private jdResponse: JdData = null;
  showSyncCandidateSpinner: boolean = false;
  planRefreshInterval: any = null;

  /**
   * Used for all criteria for AI Screening for job application
   */
  aiScreeningMasterForm = this.fb.group({
    criteria_0: this.fb.group({
      question: new UntypedFormControl(),
      id: new UntypedFormControl(null)
    })
  });

  /** Available integration variable */
  availableIntegrations: (IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean })[] = [];

  removedCriteriaOnEdit = [];
  formChangeSubscription: any;
  successMessage: string = '';
  errorMessage: string = '';
  infoMessage: string = '';

  @ViewChild('editEvaluationCriteria') editEvaluationCriteria: TemplateRef<any>;

  progress = 0;
  jobId: any
  private intervalId: any;

  showProgressBar: boolean = true;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private aiSourcingService: AiSourcingService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private modelService: NgbModal,
    private freemiumAPIService: FreemiumAPIService,
    private atsResumeScreenService: AtsResumeScreenService,
    private localStorageService: LocalStorageService,
    private activeModal: NgbActiveModal,
    private atsResumePollingService: AtsResumePollingService,
    private unifiedService: UnifiedService
  ) { }

  ngOnInit() {

    this.getATSConnectedDetails();

    if (window.location.pathname?.split('/')[2] === 'job-details') {
      this.jobid = window.location.pathname?.split('/')[3];
      this.getStatusOfResumeScreening();  
      this.showProgressBar = true;
      this.startInterval();
    } else {
      const storedJobDetails = JSON.parse(this.localStorageService.getItem('jobdetails'));
      if (storedJobDetails) {
        this.jobDetails = storedJobDetails;
      } else {
        this.jobDetails = {};
      }
    }

    setTimeout(() => {
      if (this.tab) {
        this.isProjectDetailsEvaluationCriteriaTab = true;
        this.populateScreeningData(this.jobDetails?.data?.screening_criteria);
      } else {
        this.isProjectDetailsEvaluationCriteriaTab = false;
      }
    });

    this.getSuggestedEvaluationCriteria();


  }

  /**
   * Get connected ats details
   */
  getATSConnectedDetails() {
    this.unifiedService.getUserUnifiedIntegrations('', true).subscribe((integrations: any) => {
      if (integrations.status == 'success') {
        this.availableIntegrations = integrations.data;
      }
    });
  };

  /**
   * Method to handle change criteria position with drop and drag
   * @param event
   */
  onDrop(event: CdkDragDrop<string[]>) {
    const keys = this.formLength();

    moveItemInArray(keys, event.previousIndex, event.currentIndex);

    const reorderedForm: any = {};
    keys.forEach(key => {
      reorderedForm[key] = this.aiScreeningMasterForm.get(key);
    });
    this.aiScreeningMasterForm = this.fb.group(reorderedForm);
  };

  /**
   * Method to handle edit evaluation criteria
   * @param type
   */
  enableEditMode(type: String) {
    if (type == 'edit') {
      if (!this.availableIntegrations.length && this.jobDetails?.data?.source == 'import') return;
      this.editMode = true;
    } else {
      this.editMode = false;
    }
  };

  /**
   * Method to fetch project suggested evaluation criteria
   */
  getSuggestedEvaluationCriteria() {
    this.showEvaluationCriteriaLoader = true;
    const payload = { jobdescription: this.jobDetails?.data?.description || '' };

    this.freemiumAPIService.fetchScreeningCriteriaSuggestions(payload).subscribe((res: any) => {
      this.showEvaluationCriteriaLoader = false;
      if (res && res.status == 'success') {
        const validCriteriaSuggestions = (res?.data || []).map((item: any) => item).filter(Boolean);
        if (validCriteriaSuggestions.length) {
          this.SUGGESTED_CRITERIA = res.data?.map((item: any) => ({ suggestion_content: item, selected: false }));
        }
      } else {

      }
    })
  };



  /**
   * Populate data(criteria questions) into screnning form comping from backend
   * @param data
   */
  populateScreeningData(data: SCREENING_CRITERIA[]) {
    const sortedData = data.sort((a, b) => a.criteria_priority - b.criteria_priority);
    const formGroup = this.aiScreeningMasterForm;

    Object.keys(formGroup.controls).forEach(key => {
      if (key.startsWith('criteria_')) {
        formGroup.removeControl(key);
      }
    });

    sortedData.forEach((item, index) => {
      const controlName = `criteria_${index}`;

      const control = this.fb.group({
        question: [item.criteria_content],
        id: [item.ats_criteria_id]
      });

      formGroup.addControl(controlName, control);
    });

    this.refreshCriteriaSuggestionsBasedOnFormState();
  }

  /**
   * Update criteria suggestions on the UI based on criteria form current state
   */
  refreshCriteriaSuggestionsBasedOnFormState() {
    const formGroup = this.aiScreeningMasterForm;
    const formGroupKeys = Object.keys(formGroup.controls);
    this.SUGGESTED_CRITERIA.forEach(suggestion => {
      const selectedSuggestionIdx = formGroupKeys.findIndex(key => {
        const FG = formGroup.controls[`${key}`] as UntypedFormGroup;
        return FG.getRawValue()?.question?.trim()?.toLowerCase() === suggestion.suggestion_content.trim().toLowerCase();
      });
      if (selectedSuggestionIdx !== -1) {
        suggestion.selected = true;
      } else {
        suggestion.selected = false;
      }
    });
    this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);
  }

  /**
   * Add new criteria form
   */
  addNewCriteria(data = null) {
    const formGroup = this.aiScreeningMasterForm;
    const uniqueId: string = GlobalService.generateUniqueId();
    if (data) {
      formGroup.addControl(`criteria_${uniqueId}`, new UntypedFormGroup({
        question: new UntypedFormControl(data?.criteria_content),
        id: new UntypedFormControl(data?.criteria_id)
      }));
    } else {
      formGroup.addControl(`criteria_${uniqueId}`, new UntypedFormGroup({
        question: new UntypedFormControl(),
        id: new UntypedFormControl(null)
      }));
    }

    /**
  * Add Evaluation Criteria
  */
    const evaluationParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "Criteria": data?.criteria_content

    }
    clevertap.event.push("Autopilot-Add AI Evaluation Criteria", evaluationParams);
  }

  /**
   * Delete any criteria from ai screening
   * @param formGroup
   */
  deleteCriteria(formGroup) {
    const fg = this.aiScreeningMasterForm.controls[`${formGroup}`] as UntypedFormGroup;
    const deletedCriteriaId = fg.controls['id'].value;
    if (deletedCriteriaId) {
      this.removedCriteriaOnEdit.push({
        action: 'DELETE',
        criteria_id: deletedCriteriaId
      });
    }
    this.aiScreeningMasterForm.removeControl(formGroup);
    this.refreshCriteriaSuggestionsBasedOnFormState();

    /**
  * Delete Evaluation Criteria
  */
    const evaluationParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "Criteria": deletedCriteriaId

    }
    clevertap.event.push("Autopilot-Delete AI Evaluation Criteria", evaluationParams);
  }

  /**
   * Method to open Edit Evaluation Criteria Model
   */
  openEditEvaluationCriteriaModel() {
    if (this.jobDetails?.candidatesCount) {
      this.modelService.open(this.editEvaluationCriteria, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      this.submitChanges();
    };
  };


  /**
   * Used to update or submit criteria questions
   */
  submitChanges() {
    const data = this.aiScreeningMasterForm.getRawValue();

    /** Get All the scrining criteria and store temporary*/
    const tempArr = [];
    let criteriaValidationCheck = false;
    for (let item in data) {
      tempArr.push(data[item]);
    }

    const payloadData = [];
    tempArr.forEach((item, i) => {

      if (!item.question || !item.question.trim()) criteriaValidationCheck = true;
      if (item.id) {
        payloadData.push({
          ats_criteria_id: item.id,
          criteria_content: item.question,
          criteria_priority: i + 1

        });
      } else {
        payloadData.push({
          ats_criteria_id: null,
          criteria_content: item.question,
          criteria_priority: i + 1
        });
      }
    });

    // if (this.removedCriteriaOnEdit.length) {
    //   this.removedCriteriaOnEdit.forEach((item) => {
    //     payloadData.push({
    //       action: "DELETE",
    //       criteria_id: item.criteria_id
    //     })
    //   })
    // }

    if (criteriaValidationCheck) {
      this.errorMessage = `Please Enter Valid ScreenAI Criteria`;
      setTimeout(() => {
        this.errorMessage = '';
      }, 3000);
      this.dismiss();
      return;
    };


    if (!this.editMode) {
      const syncData = {
        status: 'OPEN',
        source: this.jobDetails?.calledfrom == 'job-create' ? 'create' : 'import',
        unifiedJobId: this.jobDetails?.data?.id ? this.jobDetails?.data?.id : null,
        name: this.jobDetails?.data?.name,
        location: this.jobDetails?.calledfrom == 'job-create' ? this.jobDetails?.data?.location : this.jobDetails?.data?.addresses?.length ? this.jobDetails?.data?.addresses[0] : {},
        industry: this.jobDetails?.data?.industry,
        description: this.jobDetails?.data?.description,
        screening_criterias: payloadData,
        unified_created_at: this.jobDetails?.calledfrom !== 'job-create' ? this.jobDetails?.data?.createdAt : null,
        unified_updated_at: this.jobDetails?.calledfrom !== 'job-create' ? this.jobDetails?.data?.updatedAt : null,
        unified_company_id: this.jobDetails?.calledfrom !== 'job-create' ? this.jobDetails?.data?.companyId : null
      }

      this.atsResumeScreenService.insertJobInATS(syncData).subscribe((res: any) => {
        this.showSyncCandidateSpinner = false;
        if (res && res.success) {
          this.modelService.open(this.jobCreatedSuccessfullModel, { windowClass: 'jobCreatedSuccessModal', centered: true, backdrop: 'static', keyboard: false })
          this.increaseProgress(res.data.atsJobId)
        } else {
          this.errorMessage = 'Something went wrong. Please try again later';
          setTimeout(() => { this.errorMessage = ''; }, 3000);
        };
      })

    } else {
      this.showExploreCandidateSpinner = true;
      this.atsResumeScreenService.updateJobScreeningCriteria(payloadData, this.jobid).subscribe((res: any) => {
        this.showExploreCandidateSpinner = false;
        if (res && res.body && res.body?.status == "success") {
          this.successMessage = 'Criteria Updated Successfully';
          setTimeout(() => { this.successMessage = ''; }, 3000);
          this.dismiss();
          this.editMode = false;  
          if(this.jobDetails?.candidatesCount) {
            this.router.navigate([`/resume-screen/candidate-listing/${this.jobid}`]);
          };
        } else {
          this.errorMessage = 'Something went wrong. Please try again later';
          setTimeout(() => { this.errorMessage = ''; }, 3000);
          this.dismiss();
        };
      }, (err) => {
        this.errorMessage = 'Something went wrong. Please try again later';
        setTimeout(() => { this.errorMessage = ''; }, 3000);
        this.showExploreCandidateSpinner = false;
        this.dismiss();
      });
    }
  }
  increaseProgress(jobId: any) {
    this.intervalId = setInterval(() => {
      if (this.progress >= 100) {
        clearInterval(this.intervalId);
        this.router.navigate([`/resume-screen/candidate-listing/${jobId}`]);

        this.modelService.dismissAll()
      } else {
        this.progress += 6; // control speed
      }
    }, 300); // control timing
  }


  /**
   * reset screening form to inital state
   */
  screeningFormReset() {
    this.aiScreeningMasterForm = this.fb.group({
      criteria_0: this.fb.group({
        question: new UntypedFormControl(),
        id: new UntypedFormControl(null)
      })
    });
    // this.getEvaluationCriteria();
  }


  /**
   * Length of Form Group used to know the count of sub-forms present
   */
  formLength() {
    const innerFormGroup = this.aiScreeningMasterForm.controls;
    return Object.keys(innerFormGroup);
  }


  /**
   * Use given static criteria
   * @param c criteia (question)
   */

  /**
   * Use given static criteria
   * @param c criteria (question)
   */
  useGivenCriteria(c: SCREENING_CRITERIA_SUGGESTION) {
    this.hideSuggestions = true;
    const formKeys = Object.keys(this.aiScreeningMasterForm.controls);
    if (formKeys.length) {
      const emptyKey = Object.keys(this.aiScreeningMasterForm.controls).pop();
      const firstFG = this.aiScreeningMasterForm.controls[emptyKey] as UntypedFormGroup;

      if (!firstFG.getRawValue()?.question?.trim()) {
        firstFG.patchValue({ question: c.suggestion_content });
      } else {
        this.addNewCriteria({
          criteria_content: c.suggestion_content,
          criteria_id: null
        });
      }
    } else {
      this.addNewCriteria({
        criteria_content: c.suggestion_content,
        criteria_id: null
      });
    }
    c.selected = true;
    this.SUGGESTED_CRITERIA.sort(criteria => criteria.selected ? 1 : -1);

    /**
   * Add Evaluation Criteria
   */
    const evaluationParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "Criteria": c.suggestion_content

    }
    clevertap.event.push("Autopilot-Add AI Evaluation Criteria", evaluationParams);
  };

  /**
   * used to know either first form in empty or not
   * @returns
   */
  emptyFirstForm() {
    if (Object.keys(this.aiScreeningMasterForm.controls)?.length) {
      const formName = Object.keys(this.aiScreeningMasterForm.controls)[0];
      const FG = this.aiScreeningMasterForm.controls[`${formName}`] as UntypedFormGroup;
      if (FG && FG.getRawValue()?.question?.length) {
        return false;
      }
    }
    return true;
  }

  /**
   * used to know whether last form is empty or not
   */
  emptyLastForm() {
    if (Object.keys(this.aiScreeningMasterForm.controls)?.length) {
      const formName = Object.keys(this.aiScreeningMasterForm.controls).pop();
      const FG = this.aiScreeningMasterForm.controls[`${formName}`] as UntypedFormGroup;
      if (FG && FG.getRawValue()?.question?.length) {
        return false;
      }
    }
    return true;
  }

  ngOnDestroy() {
    this.formChangeSubscription?.unsubscribe();
    clearInterval(this.intervalId);
    clearInterval(this.planRefreshInterval);
  }

  /**
   * Method to redirect on blog page
   */
  learnMoreDetails() {
    window.open('https://fire-crib-a04.notion.site/Learn-how-to-use-AI-Sourcing-most-effectively-264d71872fa5806aa880c8ae3481d95f');
  };

  /**
   * Close job created model and redirect on job listing page
   */
  closeJobCreatedModel() {
    this.dismiss();
    this.router.navigate(['/resume-screen']);
  };

  /**
   * Method to handle the dismissal of the project list component.
   */
  dismiss() {
    this.modelService.dismissAll();
    this.showExploreCandidateSpinner = false;
  }

  /**
   * Handle status API polling state
   */
  getStatusOfResumeScreening() {
    this.atsResumeScreenService.syncCandidate(this.jobid).subscribe((res: any) => {
      if (res?.body && res?.body?.data && (res?.body?.data?.status == 'pending' || res?.body?.data?.status == 'validating' || res?.body?.data?.status == 'completed')) {
        this.progress = res.body.data?.progress == null ? 0 : res.body.data?.progress;
        if (this.progress >= 100) {
          this.showProgressBar = false;
          clearInterval(this.planRefreshInterval);
        }
      } else if (res?.body && res?.body?.data?.status == 'no-data') {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
      } else if (res?.body && res?.body?.data?.status == 'no-batch-found') {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
      } else {
        clearInterval(this.planRefreshInterval);
        this.showProgressBar = false;
      }
    })
  }

  /**
   * Start polling when is required
   */
  startInterval() {
    this.planRefreshInterval = setInterval(() => {
      this.getStatusOfResumeScreening();
    }, 10000);
  };

};
